﻿
import React from 'react';

export const Divider = (props) => {
  const wrappingClass = ['single-step__divider', props.hideOnDesktop && 'single-step__divider--hideondesktop'].join(' ');

  return (
    <div className={wrappingClass}>
      <hr />
      {props.text && <span>{props.text}</span>}
    </div>
  )
}
